import { IFreelancerSearchResponse } from '../../interfaces/freelancerSearch';
import { ITableAction, ITableCheckbox, ITableColumn, ITableData } from '../../interfaces/tableProps';
import { useMemo } from 'react';
import AppTable from '../common/AppTable';
import { theme } from '../../theme';
import { ColumnFlexBox } from '../common/boxes';
import SearchHeader from '../common/SearchHeader';
import { Box } from '@mui/material';
import { ISearchHeaderInputProps, ISearchHeaderProps } from '../../interfaces/searchHeaderProps';
import { FREELANCERS_PATH } from '../../router/paths';
import { CUSTOMER_STATUS_MAP, CustomerStatus } from '../../enums/customerStatus';

const initialColumns: ITableColumn<keyof IFreelancerSearchResponse>[] = [
  {
    name: 'id',
    label: 'ID',
    sx: { '&:hover': { cursor: 'pointer', textDecoration: 'underline', color: theme.palette.primary.dark } },
    withCopyIcon: true,
  },
  { name: 'firstName', label: 'First Name' },
  { name: 'lastName', label: 'Last Name' },
  { name: 'email', label: 'Email' },
  { name: 'phone', label: 'Phone' },
  { name: 'country', label: 'Country' },
  { name: 'town', label: 'Town' },
  { name: 'emailVerified', label: 'Email verified', format: (val: boolean) => val.toString() },
  { name: 'status', label: 'Status', format: (val: CustomerStatus) => CUSTOMER_STATUS_MAP[val] }
];

interface IProps {
  tableData: ITableData<IFreelancerSearchResponse>;
  searchProps: Omit<ISearchHeaderProps, 'inputProps'>;
  columns?: ITableColumn<keyof IFreelancerSearchResponse>[];
  searchInputProps: ISearchHeaderInputProps[];
  checkbox?: ITableCheckbox;
  tableActions?: ITableAction[];
  //Namespaces are used when the table is opened in a Modal and to avoid confusing with background table params if exists. They are optional with default values.
  pageNamespace?: string;
  sizeNamespace?: string;
}

const FreelancersTableWithSearch = ({
                                      tableData,
                                      searchProps,
                                      columns,
                                      searchInputProps,
                                      checkbox,
                                      pageNamespace,
                                      sizeNamespace,
                                      tableActions
                                    }: IProps) => {
  const handlers: { [key: string]: (val: IFreelancerSearchResponse) => void } = useMemo(() => ({
    id: (f) => window.open(FREELANCERS_PATH + `/${f.id}`, '_blank', 'noopener,noreferrer'),
  }), []);

  return (
    <ColumnFlexBox>
      <Box mb={6}>
        <SearchHeader {...searchProps} initialExpanded={true} inputProps={searchInputProps}/>
      </Box>
      <AppTable
        data={tableData}
        columns={columns || initialColumns}
        handlers={handlers}
        labelRowsPerPage={'Freelancers per page'}
        actions={tableActions}
        checkbox={checkbox}
        pageNamespace={pageNamespace}
        sizeNamespace={sizeNamespace}
      />
    </ColumnFlexBox>
  );
};

export default FreelancersTableWithSearch;